import { Provider } from 'react-redux';
import { ThemeProvider, styled } from '@mui/material';
import { store } from 'store';
import { ApiProvider } from 'contexts/ApiContext';
import Router from "routes/sections";
import theme from 'theme';

import SnackbarProvider from 'components/snackbar/snackbar-provider';

//import CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

import "assets/styles/index.scss";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <ApiProvider>
            <Router />
          </ApiProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
